import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'queoval-virtual-num-pad',
  templateUrl: './virtual-num-pad.component.html',
  styleUrls: ['./virtual-num-pad.component.css']
})

export class VirtualNumPadComponent implements OnInit {

  public tblPad: number[][] = [[],[]];
  public pswd: string = "";
  passwordVisible: boolean = false;

  @Input('enableNumpad') enableNumpad: boolean = false;

  constructor() { }

  ngOnInit(): void {

    const tbl: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    tbl.sort(() => Math.random() - 0.5);

    for (let i: number = 0; i < 2; i++) {
      for (let j: number = 0; j < 5; j++) {
        if (i > 0) this.tblPad[i].push(tbl[j + 5]);
        else this.tblPad[i].push(tbl[j]);
      }
    }
  }

  addToInput(v: number) {
    this.pswd += v.toString();
  }

  inputClear() {
    this.pswd = "";
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
}
